import React, { Component } from 'react'
import {NavLink,withRouter} from 'react-router-dom'
import {
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'

class Sidebar extends Component {
  constructor(){
    super()
    this.state = {
      currentUrl:''
    }
    this.getNavLink = this.getNavLink.bind(this)
    this.getNavLinkShow = this.getNavLinkShow.bind(this)
  }
  getNavLink = (path) => {
    return this.props.location.pathname === path ? 'active' :'';
  }
  getNavLinkShow = (path) => {
    return this.props.location.pathname.indexOf(path) !== -1 ? 'show' :'';
  }
  render() {
    return (
      <div className="side-nav">
        <div className="side-nav-inner">
          <ul className="side-nav-menu" style={{"overflow-y": "scroll"}}>
            <UncontrolledDropdown nav inNavbar className={this.getNavLinkShow('/dashboard')}>
              <DropdownToggle tag="a" caret aria-haspopup={false} aria-expanded={true}>
                <span className="icon-holder">
                  <i className="anticon anticon-dashboard"></i>
                </span>
                <span className="title">Dashboard</span>
                <span className="arrow">
                  <i className="arrow-icon"></i>
                </span>
              </DropdownToggle>
              <DropdownMenu tag="ul" className={this.getNavLinkShow('/dashboard/')}>
                <li className={this.getNavLink('/dashboard')}>
                  <NavLink to="/dashboard" activeClassName="active">Show</NavLink>
                </li>
                <li className={this.getNavLink('/diemdanh')}>
                  <NavLink to="/diemdanh" activeClassName="active">Điểm danh</NavLink>
                </li>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav inNavbar className={this.getNavLinkShow('/diemdanh')}>
              <DropdownToggle tag="a" caret aria-haspopup={false} aria-expanded={true}>
                <span className="icon-holder">
                  <i className="anticon anticon-form"></i>
                </span>
                <span className="title">Điểm danh</span>
                <span className="arrow">
                  <i className="arrow-icon"></i>
                </span>
              </DropdownToggle>
              <DropdownMenu tag="ul" className={this.getNavLinkShow('/diemdanh/')}>
                <li className={this.getNavLink('/diemdanh')}>
                  <NavLink to="/diemdanh" activeClassName="active">Danh sách</NavLink>
                </li>
                <li className={this.getNavLink('/diemdanh/new')}>
                  <NavLink to="/diemdanh/new" activeClassName="active">Tạo bảng điểm danh mới.</NavLink>
                </li>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav inNavbar className={this.getNavLinkShow('/users')}>
              <DropdownToggle tag="a" caret aria-haspopup={false} aria-expanded={true}>
                <span className="icon-holder">
                  <i className="anticon anticon-contacts"></i>
                </span>
                <span className="title">Thành viên</span>
                <span className="arrow">
                  <i className="arrow-icon"></i>
                </span>
              </DropdownToggle>
              <DropdownMenu tag="ul" className={this.getNavLinkShow('/users')}>
                <li className={this.getNavLink('/users')}>
                  <NavLink to="/users" activeClassName="active">Danh sách thành viên</NavLink>
                </li>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav inNavbar className={this.getNavLinkShow('/contents')}>
              <DropdownToggle tag="a" caret aria-haspopup={false} aria-expanded={true}>
                <span className="icon-holder">
                  <i className="anticon anticon-picture"></i>
                </span>
                <span className="title">Nội dung</span>
                <span className="arrow">
                  <i className="arrow-icon"></i>
                </span>
              </DropdownToggle>
              <DropdownMenu tag="ul" className={this.getNavLinkShow('/contents')}>
                <li className={this.getNavLink('/contents')}>
                  <NavLink to="/contents" activeClassName="active">Tất cả bài viết</NavLink>
                </li>
                <li className={this.getNavLink('/contents/approve')}>
                  <NavLink to="/contents/approve" activeClassName="active">Bài viết chưa phê duyệt</NavLink>
                </li>
                <li className={this.getNavLink('/contents/new')}>
                  <NavLink to="/contents/new" activeClassName="active">Đăng bài mới</NavLink>
                </li>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav inNavbar className={this.getNavLinkShow('/contents')}>
              <DropdownToggle tag="a" caret aria-haspopup={false} aria-expanded={true}>
                <span className="icon-holder">
                  <i className="anticon anticon-notification"></i>
                </span>
                <span className="title">Thông báo</span>
                <span className="arrow">
                  <i className="arrow-icon"></i>
                </span>
              </DropdownToggle>
              <DropdownMenu tag="ul" className={this.getNavLinkShow('/notification')}>
                <li className={this.getNavLink('/notification')}>
                  <NavLink to="/notification" activeClassName="active">Tất cả thông báo</NavLink>
                </li>
                <li className={this.getNavLink('/notification/new')}>
                  <NavLink to="/notification/new" activeClassName="active">Tạo thông báo mới</NavLink>
                </li>
              </DropdownMenu>
            </UncontrolledDropdown>
          </ul>
        </div>
      </div>
    )
  }
}

export default withRouter(Sidebar)


// WEBPACK FOOTER //
// ./src/components/layout/Sidebar.js